import { Component, computed, inject, input, linkedSignal } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { ChildClient, UserRolesIds } from '@models';
import { Store } from '@ngrx/store';
import { ClientManagementActions } from '@ngrx-store';

@Component({
  imports: [MatCardModule, MatFormFieldModule, MatInputModule],
  selector: 'avs-device-licensing',
  templateUrl: './device-licensing.component.html',
})
export class DeviceLicensingComponent {
  readonly client = input<ChildClient | undefined>(undefined);
  readonly userRole = input(UserRolesIds.ClientAdmin);
  protected readonly isReadOnly = computed(() => this.userRole() !== UserRolesIds.SuperAdmin);
  protected readonly isOverLimit = computed(() => {
    const client = this.client();

    return (
      client !== undefined &&
      client.monitoredDeviceCount !== undefined &&
      client.licensedDeviceCount !== null &&
      client.licensedDeviceCount !== undefined &&
      client.monitoredDeviceCount > client.licensedDeviceCount
    );
  });

  protected licensedCount = linkedSignal<string>(() => {
    const count = this.client()?.licensedDeviceCount;

    return count != null ? String(count) : '';
  });


  private readonly store = inject(Store);

  protected onInput(event: Event) {
    this.licensedCount.set((event.target as HTMLInputElement).value);
  }

  protected onBlur() {
    if (this.isReadOnly()) {
      return;
    }

    const raw = this.licensedCount();
    const parsed = raw === '' ? null : Number(raw);
    const client = this.client();

    if (!client || parsed === (client.licensedDeviceCount ?? null)) {
      return;
    }
    this.store.dispatch(
      ClientManagementActions.updateChildClient({
        clientClientId: client.id,
        clientData: {
          licensedDeviceCount: parsed,
        },
      }),
    );
  }
}
